// sectorData.js
export const sectorData = {
    "Technology": "💻",
    "Healthcare": "🏥",
    "Finance": "💰",
    "Education": "📚",
    "Manufacturing": "🏭",
    "Retail": "🛍️",
    "Real Estate": "🏢",
    "Energy": "⚡",
    "Transportation": "🚗",
    "Media & Entertainment": "🎬",
    "Agriculture": "🌾",
    "Construction": "🏗️",
    "Hospitality": "🏨",
    "Consulting": "💼",
    "Telecommunications": "📱",
    "Aerospace": "✈️",
    "Biotechnology": "🧬",
    "Environmental": "🌿",
    "Government": "🏛️",
    "Non-Profit": "🤝",
    "Legal Services": "⚖️",
    "Sports & Recreation": "🏅",
    "Arts & Culture": "🎨",
    "Consumer Goods": "🛒",
    "Mining & Resources": "⛏️",
    "Development": "🌎",
    "Humanitarian": "⛑️"
  };
  
  export const getSectorEmoji = (sector) => {
    return sectorData[sector] || "🏢"; // Default emoji if sector not found
  };
  
  // Get full sector list
  export const getSectorList = () => Object.keys(sectorData);
  
  // Get sector and emoji pairs
  export const getSectorPairs = () => 
    Object.entries(sectorData).map(([name, emoji]) => ({
      name,
      emoji
  }));